<div class="error-page-wrap">
  <!-- Error for page not found case-->
  <div class="main about-us-page">
    <div class="container">
      <div class="white-bg">
        <div class="content-box container error-page">
          <h1>Page Not Found</h1>
          <p class="desc darker">The page you are trying to access does not exist or has been moved.
            Try going back to our homepage.</p>
          <div class="copyright text-center">
            <button type="button" (click)="navigateHome()" class="app-btn btn btn-danger">Go to Home</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="site-footer">
    <div class="container">
      <div class="newsletter-wrap">
      </div>
    </div>
    <div class="footer-links">
      <div class="container">
        <div class="copyright text-center">{{footerText}}</div>
      </div>
    </div>
  </footer>
</div>